import { type MaybeRef, toValue } from 'vue';

import {
  createKubernetes,
  createKubernetesPool,
  deleteKubernetes,
  deleteKubernetesPool,
  editKubernetesPool,
  renameKubernetes,
  saveKubernetesTags,
} from './api';

export const createKubernetesMutation = () => ({
  mutationFn: (data: {
    name: string;
    version: string;
    region: string;
    node_pool: {
      name: string;
      size: string;
      count: number;
    };
    project_uuid?: string;
    tags: string[];
  }) => createKubernetes(data),
});

export const deleteKubernetesMutation = (kubernetesUuid: MaybeRef<string>) => ({
  mutationFn: () => deleteKubernetes(toValue(kubernetesUuid)),
});

export const deleteKubernetessMutation = () => ({
  mutationFn: (uuids: string[]) => Promise.all(uuids.map((uuid) => deleteKubernetes(uuid))),
});

export const renameKubernetesMutation = (kubernetesUuid: MaybeRef<string>) => ({
  mutationFn: (name: string) => renameKubernetes(toValue(kubernetesUuid), name),
});

export const saveKubernetesTagsMutation = (kubernetesUuid: MaybeRef<string>) => ({
  mutationFn: (tags: string[]) => saveKubernetesTags(toValue(kubernetesUuid), { tags }),
});

export const createKubernetesPoolMutation = (kubernetesUuid: MaybeRef<string>) => ({
  mutationFn: (data: { name: string; size: string; count: number }) =>
    createKubernetesPool(toValue(kubernetesUuid), data),
});

export const editKubernetesPoolMutation = (
  kubernetesUuid: MaybeRef<string>,
  poolUuid: MaybeRef<string>,
) => ({
  mutationFn: (data: { name: string; count: number }) =>
    editKubernetesPool(toValue(kubernetesUuid), toValue(poolUuid), data),
});

export const deleteKubernetesPoolMutation = (kubernetesUuid: MaybeRef<string>) => ({
  mutationFn: (poolUuid: string) => deleteKubernetesPool(toValue(kubernetesUuid), poolUuid),
});

export const deleteKubernetesPoolsMutation = (kubernetesUuid: MaybeRef<string>) => ({
  mutationFn: (poolUuids: string[]) =>
    Promise.all(poolUuids.map((uuid) => deleteKubernetesPool(toValue(kubernetesUuid), uuid))),
});
